import { BillingInfoPlan } from '@nx-frontend/shared/types';
import { BillingInfo } from '@nx-frontend/shared/types';
import { CouponType, OrgCoupons } from '@nx-frontend/shared/types';

export const hasAppsumoBundle = (billingInfo: BillingInfo, orgCoupons: OrgCoupons | null) => {
  if (
    orgCoupons &&
    orgCoupons.isLoaded &&
    orgCoupons.couponNumber &&
    (orgCoupons.couponNumber[CouponType.APPSUMO2023] > 0 || orgCoupons.couponNumber[CouponType.APPSUMO2020] > 0)
  ) {
    if (
      billingInfo &&
      billingInfo.plan &&
      billingInfo.active &&
      billingInfo.plan === BillingInfoPlan.APPSUMO_SUBSCRIPTION_2023
    ) {
      // do nothing
    } else {
      return true;
    }
  }
  return false;
};
